/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import * as _ from 'lodash';

import { ActivatedRoute, Router } from '@angular/router';

import { Component } from '@angular/core';
import { environment } from './../../environments/environment';

/**
 * @export
 * @class LmsTerminalComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-terminal',
  templateUrl: './terminal.component.html',
  styleUrls: ['./terminal.component.scss']
})
export class LmsTerminalComponent {

  /**
   * Creates an instance of LmsTerminalComponent.
   * @param {Router} router
   * @param {ActivatedRoute} route
   *
   * @memberOf LmsTerminalComponent
   */
  constructor(private router: Router, private route: ActivatedRoute) {
    if (_.isEmpty(this.route.snapshot.data)) {
      this.router.navigateByUrl(`/terminal/status/${new Date().getTime()}`, { skipLocationChange: environment.hideUrl });
    }

  }
}
